<!--
  ~ Copyright 2022-2026 NXGN Management, LLC. All Rights Reserved.
  -->

<div id="merchantList">
  <h1>Merchant search</h1>
  <p>
    Type in any of the following: merchant name / portion of merchant name,
    MMID, SAP ID, GCN, siteID, Location ID, Location Name, Location Alias, or
    SGPID (if applicable)
  </p>

  <form
    [formGroup]="merchantSearch"
    class="form-inline"
    id="merchantSearch"
    style="display: inline-block"
    novalidate
    (ngSubmit)="runMerchantSearch()"
    #form="ngForm"
  >
    <div id="merchantSearchInput">
      <input
        type="text"
        class="form-control"
        id="merchantSearchField"
        style="width: 400px"
        formControlName="searchInput"
        [class.valid]="
          merchantSearch.get('searchInput')!.valid &&
          (merchantSearch.get('searchInput')!.dirty ||
            merchantSearch.get('searchInput')!.touched)
        "
        [class.invalid]="
          merchantSearch.get('searchInput')!.invalid &&
          (merchantSearch.get('searchInput')!.dirty ||
            merchantSearch.get('searchInput')!.touched)
        "
      />

      <button
        type="submit"
        class="btn btn-primary ml-lg-3"
        [disabled]="searchInProgress || merchantSearch.status === 'INVALID'"
      >
        <span
          *ngIf="searchInProgress"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Search
      </button>
    </div>
  </form>
  <div class="ml-1">
    <div *ngIf="!searchInProgress">
      <small
        class="form-text text-danger"
        *ngIf="merchantSearch.status === 'INVALID'"
      >
        Type at least 2 characters
      </small>
      <small
        class="form-text text-muted"
        *ngIf="form.submitted && merchantList.length == 0"
      >
        No results found.
      </small>
      <small
        class="form-text grey"
        *ngIf="merchantList && merchantList.length > 0"
      >
        Match on {{ merchantList.length }} record(s).
      </small>
    </div>
  </div>

  <button
    id="downloadFullMerchantListButton"
    class="btn btn-primary"
    (click)="downloadFullMerchantList()"
    *ngIf="hasFinanceRole"
    [disabled]="downloadFullMerchantListInProgress"
  >
    <span
      *ngIf="downloadFullMerchantListInProgress"
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    ></span>
    Download Full Merchant List
  </button>

  <table
    class="table table-striped table-hover table-condensed"
    *ngIf="merchantList.length > 0"
  >
    <thead>
      <tr>
        <th>Merchant ID</th>
        <th>Merchant Name</th>
        <th>SAP ID</th>
        <th>PM Practice ID</th>
        <th>Location Alias</th>
        <th>SGPID</th>
        <th>Status</th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let merchant of merchantList">
        <td class="align-middle">{{ merchant.id }}</td>
        <td class="align-middle">{{ merchant.merchantName }}</td>
        <td class="align-middle">{{ merchant.customerAccountNumber }}</td>
        <td class="align-middle">{{ merchant.practiceId }}</td>
        <td class="align-middle">{{ merchant.locationAlias }}</td>
        <td class="align-middle">{{ merchant.externalMerchantId }}</td>
        <td class="align-middle">{{ merchant.status }}</td>
        <td class="align-middle">
          <button
            class="btn btn-primary btn-xs"
            routerLink="/merchants/{{ merchant.id }}"
          >
            View Detail
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<router-outlet></router-outlet>
